module.exports = __webpack_public_path__ + "img/Soluciones_Calidra.46f8acdb.svg";